module.exports = __webpack_public_path__ + "img/standardModel-icon-sentio.ed7038e1.svg";